import I18n from 'I18n';
import { Image } from 'foundations-components/transitional/components/Image';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
export const GYPSUM = '#f5f8fa';
export const OLAF = '#ffffff';
export const COMPANY_LOGO_USE = {
  EMAIL_FORM: 'email-form',
  BOOKING_CONTAINER: 'booking-container'
};
const CONTAINER_HEIGHT = '92px';
const IMAGE_HEIGHT = '76px';
const CompanyLogo = props => {
  const {
    compact,
    branding: {
      logoUrl,
      logoAltText,
      companyName
    },
    widthOverride,
    use
  } = props;
  const hasLogo = Boolean(logoUrl);
  if (!hasLogo) {
    return null;
  }
  let alt = logoAltText;
  if (!logoAltText) {
    if (companyName) {
      alt = I18n.text('prebook.brandingAltText', {
        companyName
      });
    } else {
      alt = I18n.text('prebook.brandingAltTextNoCompany');
    }
  }
  return /*#__PURE__*/_jsx(View, {
    role: "banner",
    "aria-labelledby": "logo-landmark",
    blockSize: CONTAINER_HEIGHT,
    marginBlockStart: "400",
    marginBlockEnd: compact ? '400' : '0',
    backgroundColor: use === COMPANY_LOGO_USE.EMAIL_FORM ? 'fill-surface-default' : undefined,
    children: /*#__PURE__*/_jsx(Image, {
      maxInlineSize: "100%",
      maxBlockSize: IMAGE_HEIGHT,
      inlineSize: widthOverride || '100%',
      blockSize: "100%",
      "data-test-id": `logo-landmark-${use}`,
      marginInline: "auto",
      objectFit: "contain",
      src: logoUrl,
      alt: alt
    })
  });
};
export default CompanyLogo;